import { companySizes } from '@/api/common/master-lists'

const data = {
  items: sessionStorage.getItem('companySizes')
    ? JSON.parse(sessionStorage.getItem('companySizes'))
    : [],
  loading: false
}

export default {
  namespaced: true,
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },

    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Get all CompanySize.
     *
     * @param {*} param
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return companySizes.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('companySizes', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
        .finally(() => commit('SET_LOADING', false))
    }
  }
}
